export default {
  "title": "半度云空间",
  "expand": "扩容云存储",
  "intro": "半度云空间是照片直播、活动资料等文件的统一存储池。当前照片直播共占用 {used}，",
  "unlimitedPlan": "当前套餐云存储空间不限量。",
  "photoRatio": "占总空间的 {percent}%。",
  "viewPhotos": "查看照片直播 ›",
  "overview": "📊 存储总览",
  "capacity": "总容量",
  "used": "已使用",
  "available": "剩余空间",
  "utilization": "使用率",
  "unlimited": "不限",
  "usedAmount": "已使用 {amount}",
  "remainingAmount": "剩余 {amount}",
  "breakdown": "📁 存储占用分解",
  "photoNotes": "📷 照片直播存储说明",
  "photoExplanation": "每次照片直播产生的原始图片和精修图片均保存在半度云空间中，与对应的活动关联。",
  "albumUsage": "当前共 {count} 场照片直播占用 {used} 空间。",
  "exhausted": "存储空间耗尽后，新的照片直播将无法上传图片。请及时在 {membership} 中升级套餐。",
  "membership": "我的会员",
  "photos": "照片直播图片",
  "activityFiles": "活动资料文件",
  "otherFiles": "其他文件",
  "adminTitle": "半度云空间 · 全平台存储管理",
  "export": "导出明细",
  "adminIntro": "本页汇总并管理全平台用户的半度云空间用量。可查看每个企业已用空间、配额与使用率，并对临界或已满企业提醒扩容。",
  "platformOverview": "平台存储总览",
  "reserve": "平台储备总空间",
  "averageUsage": "平均使用率",
  "alerts": "存储告警",
  "alertCounts": "满 {full} / 临界 {critical}",
  "allocated": "已分配总配额",
  "reserveUsage": "平台储备总空间 {reserve} / 已使用 {used}",
  "alertBanner": "共有 {count} 个用户半度云空间使用率超过 {percent}%（含 {full} 个已满）。建议通过站内信 / 短信提醒其扩容或购买存储套餐。",
  "userDetails": "用户存储占用明细",
  "search": "搜索用户名称 / 账号",
  "allStatus": "全部状态",
  "full": "已满",
  "critical": "临界",
  "normal": "正常",
  "userAccount": "用户 / 账号",
  "plan": "套餐",
  "serviceTypes": "服务类型",
  "usedQuota": "已用 / 配额",
  "status": "状态",
  "lastActive": "最近活跃",
  "actions": "操作",
  "viewDetails": "查看明细",
  "remind": "提醒",
  "detailTitle": "云空间明细 ·",
  "usedSpace": "已用空间",
  "quota": "配额总额",
  "remaining": "剩余",
  "accountPrefix": "账号：",
  "planPrefix": "套餐：",
  "typePrefix": "类型：",
  "lastActivePrefix": "最近活跃：",
  "inactive": "未开通",
  "close": "关闭",
  "remindExpand": "提醒扩容",
  "personal": "个人",
  "company": "企业",
  "unused": "未使用",
  "reminderBody": "确认提醒「{name}」扩容半度云空间？站内信与短信通道尚未开通，请通过其他渠道联系该企业。",
  "reminderTitle": "扩容提醒",
  "understood": "知道了",
  "user": "用户",
  "account": "账号",
  "type": "类型",
  "usedGb": "已用GB",
  "quotaExport": "配额",
  "exportFilename": "半度云空间明细-{date}.csv",
  "exportSuccess": "已导出 {count} 条明细",
  "photoLiveService": "照片直播",
  "registrationService": "活动报名",
  "eventsService": "会务活动",
  "allModules": "全部模块"
}
